import { AudioManager } from "../../AudioManager";
import { HelpParameters, Help, HelpPanelColor} from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { FireFruits_ResponsivePIXIApp } from "../FireFruits/game_ResponsivePIXIApp";

// namespace SlotGames {
	export class FireFruitsLink_ResponsivePIXIApp extends FireFruits_ResponsivePIXIApp {

	
		constructor(multigameParams: MultigameParams, initData: SlotGameInitData ) {
			super(multigameParams, initData, "FireFruitsLink");
			this.spinnableReelsParams.topBorderWidth = 0;
			this.spinnableReelsParams.bottomBorderWidth = 0;
		}

    }

    
